module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_collaborate03-f66fb4f660736208bbe838260813ce64.png";